import { retryErrorSrc176Evid103 } from '@wix/error-handler-core/@wix/bi-logger-os-data/v2';
import { withoutDefaults } from '../util/withoutDefaults';
export function reportErrorRetryBi(errorHandler, params) {
  const {
    biLogger
  } = errorHandler;
  const {
    errorAccessor
  } = params;
  const {
    error
  } = errorAccessor;
  const sessionId = error == null ? void 0 : error._errorHandlerSessionId;
  if (!sessionId) {
    return;
  }
  biLogger.report(withoutDefaults(retryErrorSrc176Evid103)({
    session_id: sessionId
  }));
}
//# sourceMappingURL=reportErrorRetryBi.js.map